<script lang="ts" setup>
import {
  UNIFIED_DEV_COMPLETE_COLLECTION,
  UNIFIED_DEV_COMPLETE_NEXT_ASSET,
} from '~/graphql/documents/unified';

const props = defineProps<{
  collectionSlug: string;
}>();

const client = useUrqlClient();
const { show: showToast } = useToast();
const isLoading = ref(false);

const reloadAfter = (action: () => Promise<void>) => async () => {
  if (isLoading.value) {
    return;
  }
  isLoading.value = true;
  try {
    await action();
    window.location.reload();
  }
  catch (err) {
    isLoading.value = false;
    showToast({ variant: 'error', message: err instanceof Error ? err.message : 'Dev completion failed' });
  }
};

const completeNext = reloadAfter(async () => {
  const result = await client.mutation(UNIFIED_DEV_COMPLETE_NEXT_ASSET, { collectionSlug: props.collectionSlug });
  if (result.error) {
    throw result.error;
  }
});

const completeAll = reloadAfter(async () => {
  const result = await client.mutation(UNIFIED_DEV_COMPLETE_COLLECTION, { collectionSlug: props.collectionSlug });
  if (result.error) {
    throw result.error;
  }
});
</script>

<template>
  <div class="px-3 py-1">
    <span class="mb-1.5 block truncate text-xs text-foreground">
      {{ collectionSlug }}
    </span>
    <div class="flex items-center gap-1.5">
      <button
        class="shrink-0 rounded-md px-2 py-0.5 text-xs font-medium text-primary-foreground bg-primary hover:brightness-90 disabled:opacity-50"
        :disabled="isLoading"
        @click="completeNext"
      >
        Complete next
      </button>
      <button
        class="shrink-0 rounded-md px-2 py-0.5 text-xs font-medium text-primary-foreground bg-primary hover:brightness-90 disabled:opacity-50"
        :disabled="isLoading"
        @click="completeAll"
      >
        Complete all
      </button>
    </div>
  </div>
</template>
